<template>
  <div>
    <v-col
      v-for="(gate, i) in example"
      :key="i"
      cols="12"
      style="padding: 0"
      class="my-2"
    >
      <v-card
        @click="gateModel = gate"
        :elevation="gateModel.id == gate.id ? 2 : 0"
        :color="gateModel.id == gate.id ? '#eaeaea' : null"
        rounded="xl"
        height="80px"
        class="d-flex pa-2 justify-space-around align-items-center border cursor-pointer"
        :ripple="false"
      >
        <v-avatar>
          <!-- <v-icon>{{ gate.icon }}</v-icon> -->
          <v-img :src="gate.icon" size="50px"></v-img>
        </v-avatar>
        <v-card-text>
          <v-card-title tag="h1" color="black">
            <h4 style="color: #32325a">{{ gate.title }}</h4>
          </v-card-title>
          <v-card-subtitle style="color: #32325a">{{
            gate.subtitle
          }}</v-card-subtitle>
        </v-card-text>
        <v-card-actions>
          <v-card-text class="d-flex" v-if="gateModel.id == gate.id">
            <v-icon color="green"> mdi-check-circle-outline </v-icon>
          </v-card-text>
          <v-card-text class="d-flex" v-else>
            <v-icon color="gray"> mdi-plus-circle </v-icon>
          </v-card-text>
        </v-card-actions>
      </v-card>
    </v-col>
  </div>
</template>

<script>
export default {
  name: "selectGateSales",
  props: { value: Object },
  data() {
    return {
      example: [
        {
          id: 1,
          icon: "/media/gate/zarin.webp",
          title: "درگاه زرین‌پلاس",
          subtitle: "اتصال درگاه زرین‌پلاس به فروشگاه",
          sign: [{ name: "Merchant Token", value: "" }],
          active: false,
        },
        {
          id: 2,
          icon: "/media/gate/zarin.webp",
          title: "درگاه زرین‌پلاس",
          subtitle: "اتصال درگاه زرین‌پلاس به فروشگاه",
          sign: [{ name: "Merchant Token" }],
          active: false,
        },
        {
          id: 3,
          icon: "/media/gate/zarin.webp",
          title: "درگاه زرین‌پلاس",
          subtitle: "اتصال درگاه زرین‌پلاس به فروشگاه",
          sign: [{ name: "Merchant Token" }],
          active: false,
        },
      ],
    };
  },

  computed: {
    gateModel: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
};
</script>

<style></style>
